export const initState = {
  curated: [],
  featured: [],
  trending: [],
  releases: [],
};

export default (state = initState, { type, data }) => {
  if (type === 'UPDATE_PROVIDER_TRACKS') {
    return {
      ...state,
      [data.type]: data.tracks,
    };
  }
  return state;
};
